import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "selectAllCheckbox",
    "checkbox",
    "downloadCsvButton",
    "invitationButton",
    "sendSmsButton",
    "sendEmailButton",
    "submitSmsBtn",
    "submitEmailBtn",
    "addTagButton",
    "content",
    "emailContent",
    "subject",
    "selectedCount",
    "emailCount",
    "smsCount",
  ];

  declare selectAllCheckboxTarget: HTMLInputElement;
  declare checkboxTargets: [HTMLInputElement];
  declare contentTarget: HTMLInputElement;
  declare emailContentTarget: HTMLInputElement;
  declare subjectTarget: HTMLInputElement;
  declare downloadCsvButtonTarget: HTMLAnchorElement;
  declare invitationButtonTarget: HTMLAnchorElement;
  declare sendSmsButtonTarget: HTMLAnchorElement;
  declare sendEmailButtonTarget: HTMLAnchorElement;
  declare submitSmsBtnTarget: HTMLButtonElement;
  declare submitEmailBtnTarget: HTMLButtonElement;
  declare addTagButtonTarget: HTMLElement;
  declare selectedCountTarget: HTMLDivElement;
  declare emailCountTarget: HTMLDivElement;
  declare smsCountTarget: HTMLDivElement;
  declare hasSelectAllCheckboxTarget: boolean;
  declare hasDownloadCsvButtonTarget: boolean;
  declare hasInvitationButtonTarget: boolean;
  declare hasSendSmsButtonTarget: boolean;
  declare hasSendEmailButtonTarget: boolean;
  declare hasAddTagButtonTarget: boolean;

  connect(): void {
    if (!this.hasSelectAllCheckboxTarget) return;

    if (this.selectAllCheckboxTarget.checked) {
      this.#showButtons();
    } else {
      this.#hideButtons();
    }

    if (this.hasInvitationButtonTarget) {
      this.invitationButtonTarget.addEventListener(
        "click",
        this.handleInvitationButtonOnClick.bind(this)
      );
    }

    this.element.addEventListener(
      "change",
      this.handleCheckboxOnChange.bind(this)
    );
  }

  toggle(event: Event): void {
    const target = event.target as HTMLInputElement;

    if (target.checked) {
      this.selectAll();
    } else {
      this.deSelectAll();
    }
  }

  handleInvitationButtonOnClick(event: Event): void {
    event.preventDefault();
    const form = (event.target as HTMLAnchorElement)
      .parentNode as HTMLFormElement;
    this.appendSelectedToForm(form);
    form.submit();
  }

  handleSendSmsOnClick(event: Event): void {
    event.preventDefault();

    const form = document.getElementById("send_sms_form") as HTMLFormElement;

    this.appendSelectedToForm(form);
    this.appendInputToForm(form, "content", this.contentTarget.value);

    form.submit();
  }

  handleSendEmailOnClick(event: Event): void {
    event.preventDefault();
    const form = document.getElementById("send_email_form") as HTMLFormElement;

    this.appendSelectedToForm(form);
    this.appendInputToForm(form, "content", this.emailContentTarget.value);
    this.appendInputToForm(form, "subject", this.subjectTarget.value);

    form.submit();
  }

  appendSelectedToForm(form: HTMLFormElement): void {
    const checkedCheckboxes = this.checkboxTargets.filter(
      (x) => x.checked == true
    );

    checkedCheckboxes.forEach((checkbox) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.value = checkbox.value;
      input.name = checkbox.name;
      form.appendChild(input);
    });
  }

  appendInputToForm(form: HTMLFormElement, name: string, value: string): void {
    const hiddenContentInput = document.createElement("input");
    hiddenContentInput.type = "hidden";
    hiddenContentInput.name = name;
    hiddenContentInput.value = value;
    form.appendChild(hiddenContentInput);
  }
  selectAll(): void {
    this.checkboxTargets.forEach((checkbox) => (checkbox.checked = true));
    this.#showButtons();
  }

  deSelectAll(): void {
    this.checkboxTargets.forEach((checkbox) => (checkbox.checked = false));
    this.#hideButtons();
  }

  handleCheckboxOnChange(event: Event): void {
    if (!this.checkboxTargets.includes(event.target as HTMLInputElement))
      return;

    if (this.checkboxTargets.some((checkbox) => checkbox.checked)) {
      this.#showButtons();
    } else {
      this.#hideButtons();
    }
  }

  #hideButtons(): void {
    this.#hideCounting();
    if (this.hasDownloadCsvButtonTarget)
      this.downloadCsvButtonTarget.classList.add("hidden");

    if (this.hasInvitationButtonTarget)
      this.invitationButtonTarget.classList.add("hidden");

    if (this.hasSendSmsButtonTarget)
      this.sendSmsButtonTarget.classList.add("hidden");

    if (this.hasSendEmailButtonTarget)
      this.sendEmailButtonTarget.classList.add("hidden");

    if (this.hasAddTagButtonTarget)
      this.addTagButtonTarget.classList.add("hidden");
  }

  #showButtons(): void {
    this.#showCounting();
    if (this.hasDownloadCsvButtonTarget)
      this.downloadCsvButtonTarget.classList.remove("hidden");

    if (this.hasInvitationButtonTarget)
      this.invitationButtonTarget.classList.remove("hidden");

    if (this.hasSendSmsButtonTarget)
      this.sendSmsButtonTarget.classList.remove("hidden");

    if (this.hasSendEmailButtonTarget)
      this.sendEmailButtonTarget.classList.remove("hidden");

    if (this.hasAddTagButtonTarget)
      this.addTagButtonTarget.classList.remove("hidden");
  }

  #hideCounting(): void {
    this.selectedCountTarget.textContent = "";
    this.emailCountTarget.textContent = "";
    this.smsCountTarget.textContent = "";
    this.selectedCountTarget.classList.add("hidden");
  }

  #showCounting(): void {
    const selectedRows = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked
    );
    this.selectedCountTarget.textContent = `${selectedRows.length} Selected`;
    this.emailCountTarget.textContent = `${selectedRows.length}`;
    this.smsCountTarget.textContent = `${selectedRows.length}`;
    this.selectedCountTarget.classList.remove("hidden");
  }

  checkContentChanged(): void {
    const content = this.contentTarget.value.trim();
    const subject = this.subjectTarget.value.trim();
    const emailContent = this.emailContentTarget.value.trim();
    this.submitSmsBtnTarget.disabled = content.length === 0;
    this.submitEmailBtnTarget.disabled =
      emailContent.length === 0 || subject.length === 0;
  }
}
